import { SCHOOL } from '../apollo/queries/school';
import { DUALMATCHES } from '../apollo/queries/dualMatches';
import { OperationVariables, QueryHookOptions, useLazyQuery, useQuery } from '@apollo/client';
import { createDualMatchesClient } from '../apollo/client';
import TeamBanner from '../components/teamBanner/teamBanner';
import Schedule from '../components/schedule/schedule';
import Loader from '../components/loader/loader';
import Error from '../components/error/error';
import { getTeamConfig, getEnvConfig } from '../config/config';
import styles from './pages.module.scss';
import { Link } from 'react-router-dom';
import Tabs from '../components/tabs/tabs';
import { activeFiltersActions, useActiveFilters } from '../context/active-filter-context';
import { IListSeasons } from '../graphql-types/listSeasons';
import {
  prepareSeasonsData,
  formatedMatches,
  overviewResults
} from '../components/utilities/utilities';
import useListSeasons from '../customHooks/useListSeasons';
import { useEffect } from 'react';
import { TOURNAMENTS_FOR_TEAM } from '../apollo/queries/getTournamentsForTeam';
import Overview from '../components/overview/overview';
import { GET_ROSTER_BY_ID } from '../apollo/queries/rosterById';
import { Roster } from '../graphql-types/roster';

const dmClient = createDualMatchesClient();

const Index = () => {
  const { dispatch } = useActiveFilters();
  const thisTeam = getTeamConfig();
  const envConfig = getEnvConfig();
  const { seasonsData, seasonsLoading, seasonsError, isActiveSeason, seasonYear } =
    useListSeasons();

  let SCHOOL_VARS = {
    variables: {
      id: thisTeam.schoolId
    }
  };

  let DUALMATCHES_VAR = {
    errorPolicy: 'all',
    client: dmClient,
    variables: {
      seasonStarting: seasonYear
    }
  } as QueryHookOptions<any, OperationVariables>;

  let TOURNAMENTS_VAR = {
    client: dmClient,
    variables: {
      teamId: thisTeam.teamId
    }
  };

  const {
    loading: schoolLoading,
    error: schoolError,
    data: schoolData
  } = useQuery(SCHOOL, SCHOOL_VARS);
  const [getDualMatches, { loading: dmLoading, error: dmError, data: dmData }] = useLazyQuery(
    DUALMATCHES,
    DUALMATCHES_VAR
  );

  const {
    data: tournamentsData,
    loading: tournamentsLoading,
    error: tournamentsError
  } = useQuery(TOURNAMENTS_FOR_TEAM, TOURNAMENTS_VAR);

  const {
    data: rosterData,
    loading: rosterLoading,
    error: rosterError
  } = useQuery<Roster>(GET_ROSTER_BY_ID, {
    variables: {
      rosterId: thisTeam.teamId
    }
  });

  const listOfSeasons: IListSeasons[] = seasonsData?.listSeasons;

  useEffect(() => {
    if (listOfSeasons) {
      getDualMatches();
    }
  }, [getDualMatches, listOfSeasons]);

  const wtnTeamAverageSingle = rosterData?.rosterById.worldTennisTeamNumbers?.find(
    wtn => wtn.type === 'SINGLE'
  );

  useEffect(() => {
    const season = sessionStorage?.getItem('season');
    if (season !== null) {
      const seasonValue = JSON.parse(season);

      dispatch(activeFiltersActions.setSeason(seasonValue));
    }
  }, [dispatch, isActiveSeason]);

  if (schoolLoading || dmLoading || tournamentsLoading || seasonsLoading || rosterLoading) {
    return <Loader />;
  }
  if (schoolError || seasonsError || tournamentsError || rosterError || (dmError && !dmData)) {
    return <Error />;
  }

  return (
    <>
      <TeamBanner
        teamData={schoolData.school}
        thisTeam={thisTeam}
        view="team"
        options={prepareSeasonsData(listOfSeasons)}
        wtnTeamAverage={wtnTeamAverageSingle?.average}
      />

      <Tabs>
        <ul>
          <li>
            <Link
              data-testid="PT-team-scheduleLink"
              to={`${envConfig.root}/`}
              className={styles.selected}
            >
              Schedule
            </Link>
          </li>
          {thisTeam.playersModule === true ? (
            <li>
              <Link data-testid="PT-team-rosterLink" to={`${envConfig.root}/Roster`}>
                Roster
              </Link>
            </li>
          ) : null}
        </ul>
      </Tabs>

      <div className={styles.siteWidth}>
        {dmData?.dualMatches.length > 0 && (
          <Overview
            heading="Overview"
            subheading="Dual Match Statistics"
            {...overviewResults(formatedMatches(dmData?.dualMatches))}
          />
        )}

        <Schedule
          scheduleData={dmData?.dualMatches}
          tournamentsData={tournamentsData?.tournamentsForTeam}
        />
      </div>
    </>
  );
};

export default Index;
